import { useEffect, useState } from "react";
import { checkDeductionValidation } from "../functions/deducation";
import checkDeductionApplied from "../functions/deducation/checkDeduction";

export const useDeductionApplied = (products) => {
  const [isApplied, setIsApplied] = useState(false);
  useEffect(() => {
    checkDeductionApplied(products) ? setIsApplied(true) : setIsApplied(false);
    console.log("isApplied", checkDeductionApplied(products));
  }, [products]);
  return { isApplied };
};
